/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesDuplicateCacheKeys } from "./constants";
import type {
  PostEngagementWebhookTemplatesDuplicateProps,
  EngagementWebhookTemplatesDuplicateResult,
} from "./types";

export const postEngagementWebhookTemplatesDuplicate = reactQueryMutationAdapter(
  engagementWebhookTemplatesDuplicateCacheKeys,
  (props: PostEngagementWebhookTemplatesDuplicateProps): Promise<EngagementWebhookTemplatesDuplicateResult> => {
    return fetch("/engagement/webhook_templates/duplicate", "POST", props);
  }
);
